import React, { useState, useEffect } from "react";

export function PublicStats({ stats }) {
  const [displayToday, setDisplayToday] = useState(0);
  const [displayTotal, setDisplayTotal] = useState(0);

  useEffect(() => {
    // Animated counter
    const animate = (target, setter, duration = 900) => {
      const startTs = performance.now();
      const start = 0;
      const step = (ts) => {
        const p = Math.min(1, (ts - startTs) / duration);
        const eased = 1 - Math.pow(1 - p, 3); // easeOutCubic
        setter(Math.floor(start + (target - start) * eased));
        if (p < 1) requestAnimationFrame(step);
        else setter(target);
      };
      requestAnimationFrame(step);
    };
    animate(stats.completed_today || 0, setDisplayToday);
    animate(stats.completed_total || 0, setDisplayTotal);
  }, [stats.completed_today, stats.completed_total]);

  return (
    <div className="rounded-2xl bg-[var(--ag7-glass)] backdrop-blur-sm border border-[var(--ag7-border-soft)] p-4 shadow-xl" data-testid="public-stats">
      <div className="grid grid-cols-3 gap-2">
        <div className="text-center">
          <div className="flex items-center justify-center gap-1.5 mb-1">
            <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></span>
            <span
              data-testid="stats-completed-today-label"
              title="Zona horaria: Caracas, Venezuela (UTC−4)"
              className="text-[9px] font-mono text-zinc-400 tracking-widest uppercase"
            >
              Hoy
            </span>
          </div>
          <p className="text-2xl font-black text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-cyan-400 font-mono" data-testid="stats-completed-today">
            {displayToday}
          </p>
          <p className="text-[10px] text-zinc-500 mt-0.5">recargas</p>
        </div>
        <div className="text-center border-x border-zinc-800">
          <p className="text-[9px] font-mono text-zinc-400 tracking-widest uppercase mb-1">Total</p>
          <p className="text-2xl font-black text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-400 font-mono" data-testid="stats-completed-total">
            {displayTotal}
          </p>
          <p className="text-[10px] text-zinc-500 mt-0.5">completadas</p>
        </div>
        <div className="text-center">
          <p className="text-[9px] font-mono text-zinc-400 tracking-widest uppercase mb-1">Juegos</p>
          <p className="text-2xl font-black text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-400 font-mono" data-testid="stats-active-games">
            {stats.active_games || 0}
          </p>
          <p className="text-[10px] text-zinc-500 mt-0.5">disponibles</p>
        </div>
      </div>
    </div>
  );
}
